module.exports = __webpack_public_path__ + "static/media/dodgem(7).88b18bcc.PNG";